"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useEventListener_1 = __importDefault(require("../useEventListener"));
function useOnClickOutside({ ref, callback }) {
    const onClickOutsideListener = (0, react_1.useCallback)((event) => {
        if (!ref || !ref.current || ref.current.contains(event.target)) {
            return;
        }
        callback(event);
    }, [ref, callback]);
    const documentRef = (0, react_1.useRef)(document.body);
    (0, useEventListener_1.default)({
        eventName: "click",
        ref: documentRef,
        callback: onClickOutsideListener,
        capture: true
    });
    (0, useEventListener_1.default)({
        eventName: "touchend",
        ref: documentRef,
        callback: onClickOutsideListener,
        capture: true
    });
}
exports.default = useOnClickOutside;
